import { render } from "./BookListReorderView.vue?vue&type=template&id=03f2db3c&scoped=true"
import script from "./BookListReorderView.vue?vue&type=script&lang=js"
export * from "./BookListReorderView.vue?vue&type=script&lang=js"

import "./BookListReorderView.vue?vue&type=style&index=0&id=03f2db3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f2db3c"]])

export default __exports__